import styled from 'styled-components';
import { Modal } from '@material-ui/core';

const CouponModalStyled = styled(Modal)`
  .paper {
    position: absolute;
    width: 1050px;
    max-width: calc(100vw - 64px);
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 24px 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    outline: none;
  }
  .first_line {
    display: flex;
    align-items: center;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #212121;
      line-height: 25px;
    }
    .close {
      margin-left: auto;
      cursor: pointer;
    }
  }
  .coupon-name-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 24px;
  }
  .coupon-name {
    width: 200px;
  }
  .button-group {
    margin-left: auto;
    display: flex;
    gap: 8px;
  }
  .coupon-list {
    width: 100%;
    margin-top: 16px;
    > div {
      padding: 0;
    }
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    gap: 16px;
    margin-top: 24px;
  }
`;

export default CouponModalStyled;
